import { BCMSRecord, BCMSStateManagerCRUD, useGlobalController as useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { Account } from "model";
import { useEffect } from "react";

/**
 * @name CaptureTransfersToDD
 * @returns {React.Component}
 * @description The capture component for the transfers page with the from dropdown having a value
 * selected and the to dropdown being open.
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersToDD(props) {
    // Initialze all model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    // Initalize a new instance of BCMSStateManagerCRUD using the default page data
    // then update the from property of the transfer to the selected account
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ], checkingAccount)
        .submit();

    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // passing the updated transfer. Then update the isActive property of the to dropdown
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(data.transfer, context))
    .update([ "to", "isActive" ], true)
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    
    // Return the TransfersPage passing the data and ui variables
    return <TransfersPage data={ data } ui={ ui } />
}